import { FC, LazyExoticComponent } from 'react';

import { cva } from 'class-variance-authority';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';
import type { IconType } from 'react-icons';
import { GenericIconProps } from 'ui/components/icon/Icon';

interface PROPS {
  label: string;
  iconLeft?:
    | React.ComponentType<GenericIconProps>
    | IconType
    | LazyExoticComponent<FC<GenericIconProps>>;
  iconRight?:
    | React.ComponentType<GenericIconProps>
    | IconType
    | LazyExoticComponent<FC<GenericIconProps>>;
  className?: string;
  size?: 'sm' | 'md';
}

const iconClasses = cva([], {
  variants: {
    iconSize: {
      md: ['w-4 h-4'],
      sm: ['w-3 h-3'],
    },
  },
  defaultVariants: {
    iconSize: 'sm',
  },
});

const tagClasses = cva(
  [
    'flex items-center gap-x-[6px]',
    'bg-fill-primary border border-fill-overlay',
    'rounded',
  ],
  {
    variants: {
      size: {
        sm: ['py-[5px] px-2 max-h-[28px]', 'text-xs leading-5'],
        md: [
          'px-[9px] py-1 max-h-[30px]',
          'text-sm font-semibold leading-[22px]',
        ],
      },
    },
    defaultVariants: {
      size: SIZE.Small,
    },
  },
);

const Tag: FC<PROPS> = ({
  label,
  className,
  iconLeft: IconLeft,
  iconRight: IconRight,
  size,
}) => (
  <div className={cn(tagClasses({ size }), className)}>
    {IconLeft && <IconLeft className={cn(iconClasses({ iconSize: size }))} />}
    {label}
    {IconRight && <IconRight className={cn(iconClasses({ iconSize: size }))} />}
  </div>
);

export default Tag;
